import React from 'react'
import { useNavigate, useParams } from "react-router-dom";

import { useSelector } from 'react-redux';
const Back = () => {

    const userData = useSelector((state) => state.userSlice);

    const { groupId } = useParams()

    let navigate = useNavigate();

    return (
        <>
            {
                userData?.user?.group?.uuid !== groupId ? (
                    <span onClick={() => navigate(-1)}>
                        <span className="back cursor-pointer"><i className='fa fa-arrow-left'></i> back </span>
                    </span>
                ) : null
            }
        </>
    )
}

export default Back
